import { Stack } from '@fluentui/react';
import { Button, ButtonProps, makeStyles, shorthands, Text } from '@fluentui/react-components';
import React from 'react';

import ErrorConnection from '../svgs/ErrorConnection';

export type ErrorButton = {
	id: string;
	label: string;
	btnProps: ButtonProps;
};
type PanelErrorProps = {
	icon?: JSX.Element;
	title: string;
	errorDetails: string;
	errorBtns?: ErrorButton[];
	elements?: JSX.Element[];
	errorBtnClb?: (id: string) => void;
};
const useStyles = makeStyles({
	container: {
		...shorthands.gap('8px'),
		alignItems: 'center',
		justifyContent: 'center',
		height: '100%',
	},
	margin10: {
		...shorthands.margin('10px'),
	},
});
const PanelError: React.FC<PanelErrorProps> = (props) => {
	const { icon, title, errorBtns, errorDetails, elements, errorBtnClb } = props;
	const style = useStyles();
	return (
		<Stack className={style.container}>
			<Stack.Item>{icon ? icon : <ErrorConnection />}</Stack.Item>
			<Stack.Item>
				<Text align="center" size={600}>
					{title}
				</Text>
			</Stack.Item>
			<Stack.Item>
				<Text align="center">{errorDetails}</Text>
			</Stack.Item>
			{elements?.map((element) => (
				<Stack.Item>{element}</Stack.Item>
			))}
			<Stack.Item>
				{errorBtns?.map((el) => (
					<Button className={style.margin10} {...el.btnProps} onClick={() => errorBtnClb?.(el.id)}>
						{el.label}
					</Button>
				))}
			</Stack.Item>
		</Stack>
	);
};

export default PanelError;
